import { Routes, Route, Navigate } from 'react-router-dom'
import Dashboard from '../components/Dashboard'
import Authentication from '../components/Authentication'
import Component from '../components/Component'
import BootstrapForm from '../experiment/form/BootstrapForm'
import OrdersComponent from '../components/OrdersComponent'
export default function Routing() {
  return (
    <Routes>
      <Route path='/dashboard' element={<Dashboard />} />
      <Route path='*' element={<Navigate to='/orders' replace />}/>

      <Route path='/log-in' element={<Authentication />} />
      <Route path='/orders' element={<OrdersComponent />} />
      <Route path='/component' element={<Component />} />
      <Route path='/experiment' element={<BootstrapForm />} />
    </Routes>
  )
}